'use client'

import Box from '@mui/material/Box'
import { ReactElement } from 'react'
import { tss } from 'tss-react/mui'
import Skeleton from '../Skeleton/Skeleton'
import Bubble from './Bubble'
import { ChatBubbleProps } from './ChatBubble'

type Props = Pick<ChatBubbleProps, 'inverted' | 'gutterBottom' | 'className'> & { width?: number }

const useStyles = tss.create(({ theme }) => ({
    bubbleWrap: {
        display: 'flex',
    },
    inverted: {
        justifyContent: 'flex-end',
    },
    gutterBottom: {
        marginBottom: theme.spacing(3),
    },
    rounded: {
        borderRadius: theme.shape.borderRadius * 2,
    },
}))

function ChatBubbleSkeleton({ width = 192, inverted = false, gutterBottom = true, className }: Props): ReactElement {
    const { classes, cx } = useStyles()

    return (
        <Box
            className={cx(
                classes.bubbleWrap,
                gutterBottom && classes.gutterBottom,
                inverted && classes.inverted,
                className
            )}
        >
            <Bubble inverted={inverted} isSkeleton>
                <Skeleton variant="rectangular" width={width} height={72} innerClassName={classes.rounded} />
            </Bubble>
        </Box>
    )
}

export default ChatBubbleSkeleton
